class BoldDate {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.addClasse()
  }

  bindUI() {
    this.ui = {}
    this.ui.$day = this.el.querySelector('.js-date-day')
    this.ui.$hour = this.el.querySelector('.js-date-hour')

    this.date = new Date()
    this.options = { weekday: 'long' }
    this.lang = document.documentElement.lang
    this.weekDay = new Intl.DateTimeFormat(this.lang, this.options).format(this.date)
  }

  addClasse() {
    if(this.el.getAttribute('data-day') == this.weekDay.toLowerCase()) {
      this.ui.$day.classList.add('body--bold')
      this.ui.$hour.classList.add('body--bold')
      if (!this.ui.$day.querySelector('.sr-only')) {
        const srOnly = document.createElement('span')
        srOnly.className = 'sr-only'
        srOnly.textContent = 'Jour de la semaine en cours'
        this.ui.$day.appendChild(srOnly)
      }
    } else {
      this.ui.$day.classList.remove('body--bold')
      this.ui.$hour.classList.remove('body--bold')
      const srOnly = this.ui.$day.querySelector('.sr-only')
      if (srOnly) {
        srOnly.remove()
      }
    }
  }
}

export default BoldDate
